/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

      // ===== Menu-items zonder eigen pagina (link '#') =====
    // In DE/BE wordt '#' door Shopify '/de-de#' of '/nl-be#' en ging een klik naar de homepage.
    var isEmptyHashLink = function (a) {
        var href = (a.getAttribute('href') || '').trim();
        if (href === '#' || href === '') return true;
        return /^\/[a-z]{2}(-[a-z]{2})?\/?#$/i.test(href);
    };
    document.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest ? e.target.closest('a[href]') : null;
        if (!a || !isEmptyHashLink(a)) return;
        e.preventDefault();
        var summary = a.closest('summary');
        if (summary && summary.parentElement && summary.parentElement.tagName === 'DETAILS') {
            summary.parentElement.open = !summary.parentElement.open;
            return;
        }
        if (a.closest('.first-level')) return;
        var item = a.closest('li, .m-navigation-row, [data-collapsible], .sliderule__wrapper');
        if (!item) return;
        var toggles = item.querySelectorAll('button, [data-sliderule-open], [data-collapsible-trigger], [aria-expanded]');
        for (var i = 0; i < toggles.length; i++) {
            var t = toggles[i];
            if (t === a || t.contains(a) || a.contains(t)) continue;
            if (t.closest('li, .m-navigation-row, [data-collapsible], .sliderule__wrapper') !== item) continue;
            t.click();
            break;
        }
    }, true);

    // ===== Mobiel accordeonmenu =====
    document.addEventListener('DOMContentLoaded', function () {
        const accordionMenuItems = document.querySelectorAll('.m-navigation-row');

        accordionMenuItems.forEach(function (item) {
            const header = item.querySelector('.first-level');
            if (!header) return;

            header.addEventListener('click', function () {
                const content = item.querySelector('.m-navigation-lvl-2');
                if (!content) return;

                item.classList.toggle("open");
                header.classList.toggle("active");
                content.style.display = content.style.display === 'none' ? 'block' : 'none';
            });
        });
    });

    // ===== Desktop dropdown "Wanddecoraties" (background-styling-1) =====
    function dropdownFirstStyling() {
        var thirdDropdown = document.querySelector('.background-styling-1 .header__grandparent__links .dropdown__family:nth-child(3)');
        var fourthDropdown = document.querySelector('.background-styling-1 .header__grandparent__links .dropdown__family:nth-child(4)');
        var grandparentLinks = document.querySelector('.header__grandparent__links');
        if (!thirdDropdown || !fourthDropdown || !grandparentLinks) return;

        // Create a new div with the class "contained__family"
        var containedFamilyDiv = document.createElement('div');
        containedFamilyDiv.className = 'contained__family';

        // Append the third and fourth dropdown elements to the new div
        containedFamilyDiv.appendChild(thirdDropdown);
        containedFamilyDiv.appendChild(fourthDropdown);

        // Append the new div to the parent container
        grandparentLinks.appendChild(containedFamilyDiv);
    }

    dropdownFirstStyling();

    // ===== Desktop dropdown "Inspiratie" (background-styling-2) =====
    function dropdownSecondStyling() {
        var secondDropdown = document.querySelector('.background-styling-2 .header__grandparent__links .dropdown__family:nth-child(2)');
        var thirdDropdown = document.querySelector('.background-styling-2 .header__grandparent__links .dropdown__family:nth-child(3)');
        var grandparentLinks = document.querySelector('.background-styling-2 .header__grandparent__links');
        if (!secondDropdown || !thirdDropdown || !grandparentLinks) return;

        var containedFamilyDiv = document.createElement('div');
        containedFamilyDiv.className = 'contained__family_2';
        containedFamilyDiv.appendChild(secondDropdown);
        containedFamilyDiv.appendChild(thirdDropdown);
        grandparentLinks.appendChild(containedFamilyDiv);
    }
    // Deze functie stond al niet aan; bewust niet aangeroepen.
    void dropdownSecondStyling;

    // ===== Collectiefilter (vorm) =====
    var applyButtonClicked = false;

    function handleCheckboxClick() {
        var applyButton = document.getElementById('applyButton');
        if (!applyButton) return;
        applyButton.click();
        applyButtonClicked = true;
    }

    var checkboxes = document.querySelectorAll('.form-filter');

    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('click', handleCheckboxClick);
    });

    window.addEventListener('load', function () {
        if (applyButtonClicked) {
            var collectionWrapper = document.querySelector('.collection__products');
            if (collectionWrapper) {
                collectionWrapper.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });

    document.addEventListener('DOMContentLoaded', function() {
        var elements = document.querySelectorAll('select, input[type="radio"]');

        elements.forEach(function(element) {
            element.addEventListener('change', function() {
                var currentPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
                window.scrollTo(0, currentPos);
            });
        });
    });

    // ===== Maattabel-popup (productpagina) =====
    function openSizechartPopup() {
        var popup = document.getElementById('popup-sizechart');
        var overlay = document.getElementById('popup-sizechart--overlay');
        if (popup) popup.style.display = 'block';
        if (overlay) overlay.style.display = 'block';
    }

    function closeSizechartPopup() {
        var popup = document.getElementById('popup-sizechart');
        var overlay = document.getElementById('popup-sizechart--overlay');
        if (popup) popup.style.display = 'none';
        if (overlay) overlay.style.display = 'none';
    }

    var openSizechart = document.getElementById('open-sizechart');
    var closeSizechart = document.getElementById('close-sizechart');
    var closeSizechartCta = document.getElementById('close-sizechart-cta');

    if (openSizechart) openSizechart.addEventListener('click', openSizechartPopup);
    if (closeSizechart) closeSizechart.addEventListener('click', closeSizechartPopup);
    if (closeSizechartCta) closeSizechartCta.addEventListener('click', closeSizechartPopup);

    // ===== Tab-knoppen in de maatkeuzehulp (Woonkamer, Slaapkamer, ...) =====
    // HIP ORGNL: de knoppen hebben data-tab="image-N" (snippets/product-sizechart-popup.liquid).
    // Voorheen stond er onclick="openTab('image-N')" op, terwijl openTab niet bestond -> fout bij elke klik.
    // Voor oude/andere opmaak lezen we de naam nog steeds ook uit een onclick, en er is een werkende
    // window.openTab als vangnet.
    function showSizechartTab(tabName) {
        var x = document.getElementsByClassName("tabcontent");
        for (var i = 0; i < x.length; i++) {
            x[i].style.display = "none";
        }
        var target = tabName ? document.getElementById(tabName) : null;
        if (target) target.style.display = "block";
    }

    if (typeof window.openTab !== 'function') {
        window.openTab = function (tabName) {
            if (tabName && typeof tabName === 'object' && arguments.length > 1) tabName = arguments[1];
            showSizechartTab(tabName);
        };
    }

    document.addEventListener("DOMContentLoaded", function () {
        var tabLinks = document.querySelectorAll(".tablink");
        if (!tabLinks.length) return;

        function tabIdFor(tabLink) {
            var fromData = tabLink.getAttribute("data-tab");
            if (fromData) return fromData;
            var onclick = tabLink.getAttribute("onclick") || "";
            var match = onclick.match(/'([^']+)'/);
            return match ? match[1] : null;
        }

        function updateActiveClass(clickedTab) {
            tabLinks.forEach(function (tabLink) {
                tabLink.classList.remove("active");
            });
            clickedTab.classList.add("active");
        }

        var firstTabLink = tabLinks[0];
        showSizechartTab(tabIdFor(firstTabLink));
        firstTabLink.classList.add("active");

        tabLinks.forEach(function (tabLink) {
            tabLink.addEventListener("click", function (e) {
                e.preventDefault();
                showSizechartTab(tabIdFor(this));
                updateActiveClass(this);
            });
        });
    });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
